var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-styled',{class:['icon', _vm.name, !_vm.isDot && 'dot'],attrs:{"size":_vm.size,"marginRight":_vm.marginRight,"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }